export const blockIconsAndroidWifiNew = (
	<span className='material-symbols-outlined'>wifi</span>
);
